var React = require('react');

function Peace (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M409.54,344.25a184.93,184.93,0,0,1-31.43,41.86q-4.2,4.18-8.61,8.07L280,322.58V437.24a186.89,186.89,0,0,1-64,0V322.58l-89.5,71.6q-4.41-3.89-8.61-8.07a184.93,184.93,0,0,1-31.43-41.86L216,240.62V74.76a186.89,186.89,0,0,1,64,0V240.62Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM378.11,386.11a184,184,0,0,1-260.22,0h0a183.93,183.93,0,0,1,0-260.21c71.74-72,188.25-72.15,260.21-.41s72.16,188.25.41,260.22Z","className":"fa-primary","key":2})]);
}

Peace.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = Peace;

Peace.default = Peace;
